"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactTable = require("react-table");

var _ = require("../..");

var _tooltip = _interopRequireDefault(require("../tooltip"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Table.css");

var _styles = {
  "table": "Table__table___122DR",
  "hide-table-header": "Table__hide-table-header___2hCuQ",
  "table-row": "Table__table-row___aLTtU",
  "hover-highlight": "Table__hover-highlight___GtIAa",
  "clickable": "Table__clickable___3EVVd",
  "cell-content": "Table__cell-content___2KY1x",
  "table-header": "Table__table-header___3rD3Y",
  "align-right": "Table__align-right___2y27u",
  "custom-cell": "Table__custom-cell___LRvDB",
  "cell-status": "Table__cell-status___fp4CU",
  "pagination": "Table__pagination___3tXLN",
  "total-results": "Table__total-results___37aUx",
  "total-results-label": "Table__total-results-label___dnzWV",
  "pages": "Table__pages___12sL-",
  "numbers": "Table__numbers___1fdDj",
  "pagination-icon": "Table__pagination-icon___2CTMU",
  "current": "Table__current___2AJXf",
  "missing-data": "Table__missing-data___1XY9b",
  "empty-state-container": "Table__empty-state-container___3ciUA"
};

const styles = _bind.default.bind(_styles);

const statusColor = cell => {
  if (cell.value === 'Complete') {
    return 'success';
  }

  if (cell.value === 'Failed') {
    return 'failed';
  }

  return 'in_process';
};

const formatCell = (cell, columnOptions, row) => {
  const isStatusColumn = cell.column.Header.toString() === 'Status';
  const customCellRenderLogicIsProvided = !!columnOptions.Cell;
  const cellIsMissingDatum = cell.value === '' || cell.value === undefined;

  if (isStatusColumn) {
    return _react.default.createElement(_.Text, {
      size: 15,
      status: statusColor(cell),
      className: styles('cell-status')
    }, "\u25CF\u00A0", cell.render('Cell'));
  }

  if (customCellRenderLogicIsProvided) {
    return cell.render('Cell', {
      data: row.original
    });
  }

  if (cellIsMissingDatum) {
    return _react.default.createElement(_tooltip.default, {
      text: 'Missing data',
      className: styles('missing-data')
    }, _react.default.createElement(_.Icon, {
      name: _.IconEnum.exclamation_triangle,
      color: _.Color.semantic.$warning50,
      size: 18
    }));
  }

  return _react.default.createElement(_.Text, {
    size: 15,
    className: styles('cell-content'),
    variant: cell.column.textBold && 'medium'
  }, cell.render('Cell'));
};

const Table = (0, _mobxReact.observer)(({
  className,
  columns,
  data,
  paginationSizePerPage,
  paginationShowResultsLabel,
  paginationHideSinglePage,
  hideTableHeader,
  dataTestId,
  highlightOnHover = false,
  rowOnClick,
  emptyStateChildren,
  sortBy,
  headerColor
}) => {
  const composed_classname = (0, _bind.default)(styles('table', {
    'hide-table-header': hideTableHeader
  }), className);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    state: {
      pageIndex,
      pageSize
    }
  } = (0, _reactTable.useTable)({
    columns,
    data,
    initialState: {
      pageIndex: 0,
      pageSize: paginationSizePerPage || 10,
      sortBy: sortBy || []
    },
    autoResetPage: false
  }, _reactTable.useResizeColumns, _reactTable.useFlexLayout, _reactTable.useSortBy, _reactTable.usePagination, _reactTable.useRowState);

  const iconToShowOnSort = column => {
    if (column.isSortedDesc) {
      return _.IconEnum.up_to_line;
    }

    if (column.isSorted) {
      return _.IconEnum.down_from_line;
    }

    return _.IconEnum.sort;
  };

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("table", { ...getTableProps(),
    className: composed_classname,
    "data-testid": dataTestId
  }, !hideTableHeader && _react.default.createElement("thead", {
    style: {
      backgroundColor: headerColor
    }
  }, headerGroups.map((headerGroup, i) => _react.default.createElement("tr", { ...headerGroup.getHeaderGroupProps(),
    key: i
  }, headerGroup.headers.map((column, i) => _react.default.createElement("th", {
    key: i,
    className: styles('table-header', {
      'align-right': column.textAlignRight
    }),
    ...column.getHeaderProps(column.getSortByToggleProps())
  }, typeof column.render('Header') === 'string' ? _react.default.createElement(_.Text, {
    size: 15,
    variant: 'medium'
  }, column.render('Header'), ' ') : column.render('Header'), !column.disableSortBy && _react.default.createElement(_.Icon, {
    name: iconToShowOnSort(column),
    size: 15,
    color: _.Color.neutral._60
  })))))), _react.default.createElement("tbody", { ...getTableBodyProps()
  }, page.map((row, i) => {
    prepareRow(row);
    return _react.default.createElement("tr", { ...row.getRowProps(),
      key: i,
      className: styles('table-row', {
        'hover-highlight': highlightOnHover || rowOnClick,
        clickable: rowOnClick
      }),
      onClick: () => rowOnClick && rowOnClick(row.original, i)
    }, row.cells.map((cell, i) => {
      const columnOptions = columns[i];
      return _react.default.createElement("td", {
        className: columnOptions.Cell && styles('custom-cell'),
        key: i,
        ...cell.getCellProps(),
        align: cell.column.textAlignRight && 'right'
      }, formatCell(cell, columnOptions, row));
    }));
  }), data.length === 0 && emptyStateChildren && _react.default.createElement("tr", {
    className: styles('empty-state-container'),
    "data-testid": 'empty-container'
  }, _react.default.createElement("td", null, emptyStateChildren)))), paginationSizePerPage && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    className: styles('pagination', paginationShowResultsLabel ? 'total-results' : '')
  }, data.length > 0 && paginationShowResultsLabel && _react.default.createElement(_.Text, {
    className: styles('total-results-label'),
    size: 15,
    text: `Showing ${pageIndex * pageSize + 1}-${Math.min((pageIndex + 1) * pageSize, data.length)} out of ${data.length}`
  }), (!paginationHideSinglePage || pageOptions.length > 1) && _react.default.createElement("div", {
    className: styles('pages')
  }, _react.default.createElement(_.Button, {
    label: _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_.Icon, {
      name: _.IconEnum.angle_left,
      color: !canPreviousPage ? _.Color.neutral._60 : _.Color.neutral._90
    }), _react.default.createElement(_.Text, {
      variant: 'medium',
      size: 15,
      disabled: !canPreviousPage
    }, "Prev")),
    onClick: () => previousPage(),
    disabled: !canPreviousPage,
    variant: 'tertiary'
  }), ' ', _react.default.createElement("div", {
    className: styles('numbers')
  }, pageOptions.map((option, i) => {
    return _react.default.createElement(_.Button, {
      className: styles('pagination-icon', {
        current: pageIndex === option
      }),
      key: i,
      label: option + 1,
      onClick: () => gotoPage(option),
      variant: 'tertiary'
    });
  })), _react.default.createElement(_.Button, {
    label: _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_.Text, {
      variant: 'medium',
      size: 15,
      disabled: !canNextPage
    }, "Next"), _react.default.createElement(_.Icon, {
      name: _.IconEnum.angle_right,
      color: !canNextPage ? _.Color.neutral._60 : _.Color.neutral._90
    })),
    onClick: () => nextPage(),
    disabled: !canNextPage,
    variant: 'tertiary'
  })))));
});
var _default = Table;
exports.default = _default;